import { TranslationMap } from '@trimble-gcs/i18n-types';

export function downloadSelectListTranslations() {
  return {
    title: {
      text: $localize`:@@downloadSelectList.title:Package Contents`,
      desc: 'Label above the selectable files list.',
    },
    selectAll: {
      text: $localize`:@@downloadSelectList.selectAll:All Files`,
      desc: 'Label for the select all checkbox that selects all files in the list.',
    },
    notReady: {
      text: $localize`:@@downloadSelectList.notReady:Scan not ready`,
      desc: 'Text displayed when the file status is not ready and cannot be downloaded.',
    },
    noFiles: {
      text: $localize`:@@downloadSelectList.noFiles:No files available`,
      desc: 'Text displayed when there are no files to download.',
    },
    fileProgress: {
      tooltip: {
        text: $localize`:@@downloadSelectList.fileProgress.tooltip:File Progress: {percentageComplete}%`,
        desc:
          'Tooltip for the file progress bar that shows next to each file name, ' +
          'if the file is already being downloaded.',
      },
    },
    cancel: {
      text: $localize`:@@downloadSelectList.cancel.button:Cancel`,
      desc: 'Text for the cancel button. The button will close the panel.',
    },
    download: {
      text: $localize`:@@downloadSelectList.download.button:Download`,
      desc: 'Text for the download button that starts the download process of the selected files.',
    },
  } satisfies TranslationMap;
}
